<div class="cg">
  <div class="cg__head">
    <h2 class="cg__title">Select a channel to edit</h2>
    <button
      type="button"
      class="cg__close"
      aria-label="Close"
      (click)="close.emit()"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <path
          d="M6 6l12 12M18 6L6 18"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </button>
  </div>

  <p class="cg__hint">
    Editing resolves the product offering for a specific channel. Pick one to
    continue — เลือก channel ก่อนเข้าหน้าแก้ไข
  </p>

  <div class="cg__search">
    <svg
      width="14"
      height="14"
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="4.5" stroke="currentColor" stroke-width="1.4" />
      <path
        d="M11 11l3 3"
        stroke="currentColor"
        stroke-width="1.4"
        stroke-linecap="round"
      />
    </svg>
    <input
      type="text"
      placeholder="Search channels…"
      [(ngModel)]="search"
      aria-label="Search channels"
      [disabled]="loading && !sellsEverywhere"
    />
  </div>

  <div class="cg__list" role="listbox">
    @if (loading && !sellsEverywhere) {
    <span class="cg__sr" role="status"
      >Checking which channels this product offering can be edited on…</span
    >
    <div class="cg__skeleton" aria-hidden="true"></div>
    <div class="cg__skeleton" aria-hidden="true"></div>
    <div class="cg__skeleton" aria-hidden="true"></div>
    } @else { @for (g of groupedChannels; track g.group) {
    <div class="cg__group">{{ g.group }}</div>
    @for (c of g.items; track c.value) {
    <button
      type="button"
      role="option"
      class="cg__option"
      [class.is-selected]="c.value === selected"
      [attr.aria-selected]="c.value === selected"
      (click)="onPick(c.value)"
    >
      <span class="cg__label">{{ c.label }}</span>
      <span class="cg__code">{{ c.value }}</span>
      @if (c.value === selected) {
      <span class="cg__check" aria-hidden="true">✓</span>
      }
    </button>
    } } @if (groupedChannels.length === 0) {
    <div class="cg__empty">
      @if (search.trim()) { No channels match "{{ search }}" } @else { This
      product offering has no sellable channels to edit. }
    </div>
    } }
  </div>
</div>
